// Generated by purs version 0.13.5
"use strict";
var Affjax = require("../Affjax/index.js");
var Affjax_ResponseFormat = require("../Affjax.ResponseFormat/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except = require("../Control.Monad.Except/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List_NonEmpty = require("../Data.List.NonEmpty/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Console = require("../Effect.Console/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic = require("../Foreign.Generic/index.js");
var Items = require("../Items/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var Web_DOM_NonElementParentNode = require("../Web.DOM.NonElementParentNode/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLDocument = require("../Web.HTML.HTMLDocument/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var WebApp_App = require("../WebApp.App/index.js");
var main = function __do() {
    var v = Control_Bind.bindFlipped(Effect.bindEffect)(Web_DOM_NonElementParentNode.getElementById("root"))(Data_Functor.map(Effect.functorEffect)(Web_HTML_HTMLDocument.toNonElementParentNode)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window)))();
    if (v instanceof Data_Maybe.Nothing) {
        return Effect_Exception["throw"]("root element in html site not found")();
    };
    if (v instanceof Data_Maybe.Just) {
        return Effect_Aff.launchAff_(Control_Bind.bind(Effect_Aff.bindAff)(Affjax.get(Affjax_ResponseFormat.string)("items.json"))(function (v1) {
            return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)((function () {
                if (v1.body instanceof Data_Either.Left) {
                    return Effect_Console.log(Affjax_ResponseFormat.printResponseFormatError(v1.body.value0));
                };
                if (v1.body instanceof Data_Either.Right) {
                    var v2 = Control_Monad_Except.runExcept(Foreign_Generic.decodeJSON(Items.decodeItems)(v1.body.value0));
                    if (v2 instanceof Data_Either.Left) {
                        return Effect_Console.log(Foreign.renderForeignError(Data_List_NonEmpty.head(v2.value0)));
                    };
                    if (v2 instanceof Data_Either.Right) {
                        return React_Basic_DOM.render(WebApp_App.app({
                            items: v2.value0
                        }))(v.value0);
                    };
                    throw new Error("Failed pattern match at WebApp (line 35, column 22 - line 37, column 60): " + [ v2.constructor.name ]);
                };
                throw new Error("Failed pattern match at WebApp (line 33, column 20 - line 37, column 60): " + [ v1.body.constructor.name ]);
            })());
        }))();
    };
    throw new Error("Failed pattern match at WebApp (line 29, column 3 - line 37, column 60): " + [ v.constructor.name ]);
};
module.exports = {
    main: main
};
